import React from 'react';
import { Download, FileText, AlertCircle } from 'lucide-react';

const ReportSection = ({ 
  title, 
  description, 
  reportType, 
  selectedWeek,
  selectedMonth,
  loading,
  error,
  onDownload 
}) => {
  const reportKey = `${reportType}_report`;

  const handleDownload = () => {
    const period = selectedWeek ? 'weekly' : selectedMonth ? 'monthly' : null;
    if (period) {
      onDownload(reportType, period);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1">
          <FileText 
            className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1"
            style={{ color: '#103D4B' }}/>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1 text-left">{title}</h3>
            <p className="text-sm text-gray-600 text-left">{description}</p>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-3 flex-shrink-0 items-center">
          <button
            onClick={handleDownload}
            disabled={(!selectedWeek && !selectedMonth) || loading[reportKey]}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors text-sm font-medium"
            style={{ backgroundColor: '#103D4B' }}
          >
            {loading[reportKey] ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <Download className="w-4 h-4" />
            )}
            <span>Download Report</span>
          </button>
        </div>
      </div>
      
      {error[reportKey] && (
        <div className="mt-3 flex items-center gap-2 text-sm text-red-600 bg-red-50 p-3 rounded">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          <span>{error[reportKey]}</span>
        </div>
      )}
    </div>
  );
};

export default ReportSection;
